import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MobileCloseIcon } from "../components/ui-icons/header";
import { MobileMenuIcon } from "../components/ui-icons/menu";
import { useMenu } from "../contexts/MenuContext";
// Avatar and user name moved into MobileMenu
import Loading from "../components/Loading";
import MobileMenu from "./MobileMenu.mobile";
import { SystemType } from "../types/main";
import { NavItemType } from "./DashboardLayout";
import { SystemMenuMobile } from "src/components/SystemMenu.mobile";
import { modifiedSystemsList } from "src/modules/systems/selectors";
import { useGetSelect } from "src/hooks/redux-selectors";
import { systemsListName } from "src/api/config";
import { useNavigate, useParams } from "react-router-dom";
import { getSafeAreaTopPaddingCss } from "src/utils/mobile";

export default function DashboardMobileHeader({
  activeSystem,
  list,
}: {
  activeSystem: SystemType | null;
  list: NavItemType[];
}) {
  const { isMenuOpen, toggleMenu } = useMenu();
  const { pathname } = useLocation();
  const [menuSystems, setMenuSystems] = useState<SystemType[]>([]);
  let { data: systems } = useGetSelect(systemsListName);
  const newSystems = useMemo(() => modifiedSystemsList(systems), [systems]);
  const headerPaddingTop = useMemo(() => getSafeAreaTopPaddingCss(20), []);
  const { id = "1" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
      return;
    }

    if (id && newSystems && newSystems.length > 0) {
      const list = getLastSystems(newSystems, +id);
      setMenuSystems(list);
    }
  }, [id, newSystems, navigate]);

  function getLastSystems(systems: SystemType[], systemId: number) {
    const { menuSystems } = systems.reduce(
      (acc, system) => {
        if (system.id !== systemId) {
          acc.menuSystems.push(system);
        }
        return acc;
      },
      {
        menuSystems: [] as SystemType[],
      }
    );

    return menuSystems;
  }

  const openCloseMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    toggleMenu();
  };

  if (activeSystem === null) return <Loading />;

  return (
    <section className="flex-row hidden max-md:flex">
      <div className={"w-full md:container mx-auto flex flex-col grow"}>
        <header
          className={`flex-row ${isMenuOpen ? "fixed top-0 left-0 w-full bg-white z-40" : "relative z-40"} justify-between items-center max-md:flex max-md:px-6 pb-5 mmm`}
          style={{ paddingTop: headerPaddingTop }}
        >
          <div className="flex flex-col grow">
            <div className="flex flex-row items-center justify-between">
              <div className="flex flex-col cursor-pointer logo">
                <Link
                  to={
                    activeSystem.externalLink || pathname.endsWith(activeSystem.id.toString())
                      ? pathname
                      : pathname.split("/").slice(0, -1).join("/")
                  }
                >
                  <div className="flex flex-row items-center gap-2">
                    <img
                      className="object-contain w-6 h-6"
                      src={activeSystem.url}
                      alt={activeSystem.title}
                      srcSet={activeSystem.url}
                    />
                    <span className="text-[16px] text-black">{activeSystem.title}</span>
                  </div>
                </Link>
              </div>

              <div className="flex flex-row gap-[22px] items-center justify-center config">
                <SystemMenuMobile list={menuSystems} />
                <button className="flex" onClick={openCloseMenu}>
                  {isMenuOpen ? <MobileCloseIcon /> : <MobileMenuIcon />}
                </button>
              </div>
            </div>
          </div>
        </header>
        <MobileMenu list={list} open={isMenuOpen} />
      </div>
    </section>
  );
}
